import { StateNode } from '@ansys-internal/awf-angular/store';

export class MotorTransmissionLossState implements StateNode<string> {
  key: string = 'motorLossType';
  mutable: boolean = true;
  observeInitial: boolean = true;
  defaultValue: () => string = () => '';
}
